<!-- WCAG 4.1.3 — polite region is always mounted so dynamic text is not the first node in a newly created live region (Deque / status-messages pattern). Inner ngx-bootstrap <alert> uses role="alert" for the visible toast. -->
<div role="status" aria-live="polite" aria-atomic="true" class="server-alert-live-region">
  <ng-container *ngIf="alert">
    <alert
      (onClose)="onClose()"
      [dismissible]="alert.dismissible || false"
      [dismissOnTimeout]="alert.dismissOnTimeout || appConfig.Alert.dismissOnTimeout"
      type="{{ alert.type }}"
      class="server-alert {{ alert.position }}"
    >
      <div class="alert-body">
        {{ alert.message }}
        <p *ngIf="alert.messageDetail">
          <small>{{ alert.messageDetail }}</small>
        </p>
      </div>
    </alert>
  </ng-container>
</div>
